export enum LocalStorageKeys {
	CollaboratorInvitationProjects = 'collaborator-invitation-projects',
	DApps = 'dAppsState' // Change this name on the future
}

export enum LinksActions {
	AcceptTeamInvitation = 'accept-team-invitation' // The correct action name is accept-collaborator-invitation, this comes from the old version of the app
}
